/** Synthetic / guest emails — never show as the impersonation menu line. */
const IMPERSONATION_PLACEHOLDER_EMAIL_SUBSTRING = '@placeholder'

/** Supabase / Prisma user ids are often UUID-shaped strings. */
const IMPERSONATION_TARGET_USER_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** Basic login email shape (aligned with sign-in validation). */
const IMPERSONATION_TARGET_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function isImpersonationTargetUserIdFormat(value: string): boolean {
  return IMPERSONATION_TARGET_USER_ID_RE.test(value.trim())
}

export function isImpersonationTargetEmailFormat(value: string): boolean {
  const t = value.trim()
  if (!t || t.length > 320) return false
  return IMPERSONATION_TARGET_EMAIL_RE.test(t)
}

/** Non-empty draft that is either a UUID-shaped id or a plausible email. */
export function isImpersonationTargetDraftValid(value: string): boolean {
  const t = value.trim()
  if (!t) return false
  return isImpersonationTargetUserIdFormat(t) || isImpersonationTargetEmailFormat(t)
}

/** Fields needed to build the “Viewing as …” line (operator menu). */
export interface ImpersonationMenuTargetProfile {
  email: string | null
  firstName: string | null
  lastName: string | null
  username: string
}

/**
 * Prefer a real account email for the impersonation strip; never fall back to internal-style usernames.
 */
export function buildImpersonationMenuTargetLabel(profile: ImpersonationMenuTargetProfile): string {
  const email = profile.email?.trim() ?? ''
  if (email.length > 0 && !email.toLowerCase().includes(IMPERSONATION_PLACEHOLDER_EMAIL_SUBSTRING)) {
    return email
  }
  const name = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim()
  if (name.length > 0) return name
  return 'User'
}
